import { countrySelectorValues } from "./data";

export function dataDeepCopy<T>(data: T) {
  return JSON.parse(JSON.stringify(data)) as T;
}

export const logErrors = (error: unknown, data?: any) => {
  // if (data) {
  //   Sentry.setContext("Logged Data", data);
  // }
  // Sentry.captureException(error);

  if (process.env.NODE_ENV === "development") {
    console.log(error, data);
  }
};

export const validateImageType = (type: string) => {
  const fileTypes = ["image/jpeg", "image/png"];

  return fileTypes.includes(type);
};

export const validateFileSize = (size: number, limit = 1048576 * 2) => {
  return size <= limit;
};

export const getCountryByCode = (code: string) => {
  const countryObj = countrySelectorValues.find((c) => c.value === code);
  return countryObj ? countryObj.title : code;
};
